import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { find } from "lodash";
import React from "react";
import { GridLabel, GridinRow } from "utils/style";

interface IScheduleDetailProp {
  schedule: IDetailCcaStudentSchedule;
  dropOffType: string;
  ccaAreas: IArea[];
  fixedLocations: ICcaFixedLocationDropOff[];
  waves: IBusSchedule[];
}

interface ILocationByDay {
  day: string;
  fixedLocationId?: number;
  waveId?: number;
  ccaAreaId?: number;
}

const CcaScheduleDetail = ({
  schedule,
  dropOffType,
  ccaAreas,
  fixedLocations,
  waves,
}: IScheduleDetailProp) => {
  const days: ILocationByDay[] = [];

  const fixedLocationRowStyle = {
    borderBottom: "1px solid #ccc",
    marginBottom: "5px",
    paddingBottom: "7px",
  };

  if (schedule.isMonday) {
    days.push({
      day: "Monday",
      fixedLocationId: schedule.fixedLocationMondayId,
      waveId: schedule.waveMondayId,
      ccaAreaId: schedule.ccaAreaMondayId,
    });
  }
  if (schedule.isTuesday) {
    days.push({
      day: "Tuesday",
      fixedLocationId: schedule.fixedLocationTuesdayId,
      waveId: schedule.waveTuesdayId,
      ccaAreaId: schedule.ccaAreaTuesdayId,
    });
  }
  if (schedule.isWednesday) {
    days.push({
      day: "Wednesday",
      fixedLocationId: schedule.fixedLocationWednesdayId,
      waveId: schedule.waveWednesdayId,
      ccaAreaId: schedule.ccaAreaWednesdayId,
    });
  }
  if (schedule.isThursday) {
    days.push({
      day: "Thursday",
      fixedLocationId: schedule.fixedLocationThursdayId,
      waveId: schedule.waveThursdayId,
      ccaAreaId: schedule.ccaAreaThursdayId,
    });
  }
  if (schedule.isFriday) {
    days.push({
      day: "Friday",
      fixedLocationId: schedule.fixedLocationFridayId,
      waveId: schedule.waveFridayId,
      ccaAreaId: schedule.ccaAreaFridayId,
    });
  }

  return dropOffType === "door_to_door" ? (
    <SanitizedGrid container spacing={2} alignItems="center">
      <Grid item xs={4} style={GridinRow}>
        <Typography variant="body2">
          {days.map((item) => item.day).join(", ")}
        </Typography>
      </Grid>
      <Grid item xs={8} style={GridinRow}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12} style={GridinRow}>
            <Typography variant="body2" style={GridLabel}>
              Block No. : {schedule.doorToDoorAddress?.blockNumber}
            </Typography>
          </Grid>

          <Grid item xs={12} style={GridinRow}>
            <Typography variant="body2" style={GridLabel}>
              Street : {schedule.doorToDoorAddress?.street}
            </Typography>
          </Grid>

          <Grid item xs={12} style={GridinRow}>
            <Typography variant="body2" style={GridLabel}>
              Postal Code : {schedule.doorToDoorAddress.postalCode}
            </Typography>
          </Grid>

          <Grid item xs={12} style={GridinRow}>
            <Typography variant="body2" style={GridLabel}>
              Area :{" "}
              {(() => {
                const area = find(ccaAreas, [
                  "id",
                  schedule.ccaAreaDoorToDoorId,
                ]);

                if (area === undefined || area === null) {
                  return "-";
                }

                return area.name;
              })()}
            </Typography>
          </Grid>
        </SanitizedGrid>
      </Grid>
    </SanitizedGrid>
  ) : (
    <>
      {days.map((item, index) => (
        <Grid
          container
          spacing={2}
          style={
            index === days.length - 1
              ? { marginBottom: "0px" }
              : fixedLocationRowStyle
          }
          alignItems="center"
        >
          <Grid item xs={4} style={GridinRow}>
            {item.day}
          </Grid>
          <Grid item xs={8} style={GridinRow}>
            <SanitizedGrid container spacing={1}>
              <Grid item xs={12} style={GridinRow}>
                <Typography variant="body2" style={GridLabel}>
                  Location :{" "}
                  {(() => {
                    const location = find(fixedLocations, [
                      "id",
                      item.fixedLocationId,
                    ]);

                    if (location === undefined || location === null) {
                      return "-";
                    }

                    return location.name;
                  })()}
                </Typography>
              </Grid>

              <Grid item xs={12} style={GridinRow}>
                <Typography variant="body2" style={GridLabel}>
                  Area :{" "}
                  {(() => {
                    const area = find(ccaAreas, ["id", item.ccaAreaId]);

                    if (area === undefined || area === null) {
                      return "-";
                    }

                    return area.name;
                  })()}
                </Typography>
              </Grid>

              {item.waveId && item.waveId > 0 ? (
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Wave :{" "}
                    {(() => {
                      const wave = find(waves, ["id", item.waveId]);

                      if (wave === undefined || wave === null) {
                        return "-";
                      }

                      return wave.name;
                    })()}
                  </Typography>
                </Grid>
              ) : (
                <></>
              )}
            </SanitizedGrid>
          </Grid>
        </Grid>
      ))}
    </>
  );
};

export default CcaScheduleDetail;
